import { TitleStepDeployTab } from "@/pages/DeploymentsPage/components/molecules/DeployTab"

import styles from "./CloudConnectionStatus.module.scss"

import type { StepItem } from "@/atoms"

// A deploy step of a cloud connection: its title, a line on what it is for,
// and its content
export const getCloudConnectionStep = (
  title: string,
  subTitle: string,
  content?: React.ReactNode
): StepItem => ({
  title: <TitleStepDeployTab prefix={title} subTitle={subTitle} />,
  description: content && <div className={styles.container}>{content}</div>,
  status: "process"
})
